import { baseStyles } from '../base-styles';

export function getStyles(accent: string, position: string): string {
  const right = position === 'bottom-right';

  // Parse hex accent into r,g,b for rgba() usage
  const hex = accent.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) || 99;
  const g = parseInt(hex.substring(2, 4), 16) || 102;
  const b = parseInt(hex.substring(4, 6), 16) || 241;

  return baseStyles(accent) + `
    .yd-glass-bubble {
      position: fixed;
      bottom: 16px;
      ${right ? 'right: 20px;' : 'left: 20px;'}
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: rgba(${r}, ${g}, ${b}, 0.85);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      color: white;
      border: 1px solid rgba(255, 255, 255, 0.25);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 16px rgba(${r}, ${g}, ${b}, 0.3), 0 0 40px rgba(${r}, ${g}, ${b}, 0.1);
      transition: transform 0.2s, box-shadow 0.2s;
      z-index: 1;
      pointer-events: auto;
    }
    .yd-glass-bubble:hover {
      transform: scale(1.06);
      box-shadow: 0 6px 24px rgba(${r}, ${g}, ${b}, 0.45), 0 0 50px rgba(${r}, ${g}, ${b}, 0.15);
    }

    .yd-glass-panel {
      position: fixed;
      bottom: 88px;
      ${right ? 'right: 20px;' : 'left: 20px;'}
      width: 380px;
      height: 520px;
      max-height: calc(100vh - 108px);
      background: rgba(255, 255, 255, 0.85);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.3);
      border-radius: 20px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      z-index: 1;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      pointer-events: auto;
    }

    @media (max-width: 480px) {
      .yd-glass-panel {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        max-height: 100%;
        border-radius: 0;
      }
    }

    /* --- Glassmorphic overrides for shared classes --- */

    .yd-header {
      background: rgba(${r}, ${g}, ${b}, 0.8);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    }
    .yd-header-logo {
      border: 1px solid rgba(255, 255, 255, 0.3);
    }

    .yd-suggestion {
      background: rgba(243, 244, 246, 0.7);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border: 1px solid rgba(229, 231, 235, 0.8);
    }
    .yd-suggestion:hover {
      background: rgba(229, 231, 235, 0.85);
    }

    .yd-msg-user {
      background: rgba(${r}, ${g}, ${b}, 0.87);
    }
    .yd-msg-assistant {
      background: rgba(243, 244, 246, 0.7);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border: 1px solid rgba(229, 231, 235, 0.5);
    }

    .yd-typing {
      background: rgba(243, 244, 246, 0.7);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border: 1px solid rgba(229, 231, 235, 0.5);
    }

    .yd-input-area {
      border-top: 1px solid rgba(229, 231, 235, 0.5);
      background: rgba(255, 255, 255, 0.4);
    }
    .yd-input {
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid rgba(209, 213, 219, 0.6);
      transition: border-color 0.15s, background 0.15s;
    }
    .yd-input:focus {
      border-color: rgba(${r}, ${g}, ${b}, 0.6);
      background: rgba(255, 255, 255, 0.7);
    }
    .yd-send-btn {
      background: rgba(${r}, ${g}, ${b}, 0.85);
    }

    /* Fallback for browsers without backdrop-filter support */
    @supports not (backdrop-filter: blur(1px)) {
      .yd-glass-bubble {
        background: ${accent};
        border: none;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
      .yd-glass-panel {
        background: #ffffff;
        border: 1px solid #e5e7eb;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
      }
      .yd-header {
        background: ${accent};
        border-bottom: none;
      }
      .yd-msg-assistant {
        background: #f3f4f6;
        border: none;
      }
      .yd-typing {
        background: #f3f4f6;
        border: none;
      }
      .yd-suggestion {
        background: #f3f4f6;
        border: 1px solid #e5e7eb;
      }
      .yd-input {
        background: #ffffff;
        border: 1px solid #e5e7eb;
      }
      .yd-send-btn {
        background: ${accent};
      }
      .yd-msg-user {
        background: ${accent};
      }
    }
  `;
}
